import AppHeader from '../AppHeader'

export default {
  name: 'propose-detail',
  created () {
    this.search()
  },
  data () {
    return {
      canValidate: true,
      searchCallbackFlag: false,
      isReject: false,
      isApprove: false,
      lastRejectreason: null,
      rejectReason: {
        id: null,
        content: ''
      },
      approvedReason: {
        content: ''
      }
    }
  },
  computed: {
    proposeDetail () {
      return this.$store.getters.proposeDetail
    },
    rejectreasons () {
      return this.$store.getters.rejectreasonsAll
    },
    joint1User () {
      return this.$store.getters.joint1User
    },
    joint2User () {
      return this.$store.getters.joint2User
    },
    authToken () {
      return window.localStorage.getItem('access_token')
    },
    timeStamp () {
      var d = new Date()
      var year = d.getFullYear()
      var month = d.getMonth() + 1
      var day = d.getDate()
      var hour = (d.getHours() < 10) ? '0' + d.getHours() : d.getHours()
      var min = (d.getMinutes() < 10) ? '0' + d.getMinutes() : d.getMinutes()
      var sec = (d.getSeconds() < 10) ? '0' + d.getSeconds() : d.getSeconds()
      return year + '' + month + '' + day + '' + hour + '' + min + '' + sec
    },
    peaceMing () {
      return !!this.proposeDetail.attributes['idea-peace-ming']
    },
    sincere () {
      return !!this.proposeDetail.attributes['idea-sincere']
    },
    excitement () {
      return !!this.proposeDetail.attributes['idea-excitement']
    },
    comfortable () {
      return !!this.proposeDetail.attributes['idea-comfortable']
    },
    creation () {
      return !!this.proposeDetail.attributes['idea-creation']
    },
    civility () {
      return !!this.proposeDetail.attributes['idea-civility']
    },
    imagination () {
      return !!this.proposeDetail.attributes['idea-imagination']
    },
    sympathy () {
      return !!this.proposeDetail.attributes['idea-sympathy']
    },
    expression () {
      return !!this.proposeDetail.attributes['idea-expression']
    },
    challengeDream () {
      return !!this.proposeDetail.attributes['idea-challenge-dream']
    },
    validation: function () {
      return {
        reject_reason_id: !!this.rejectReason.id,
        reject_reason_content: !!this.rejectReason.content,
        reject_reason: !!this.rejectReason.id &&
                       !!this.rejectReason.content,
        approved_reason_content: !!this.approvedReason.content
      }
    },
    rejectReasonContentCount: function () {
      return this.rejectReason.content.length
    },
    approvedReasonContentCount: function () {
      return this.approvedReason.content.length
    }
  },
  components: {
    AppHeader
  },
  methods: {
    search: function () {
      var data = {}
      var self = this
      var callback = function () {
        self.searchCallbackFlag = true
        self.rejectReasonAllGet()
      }
      this.$store.dispatch('PROPOSE_DETAIL', { id: this.$route.params.id, data: data, callback: callback })
    },
    rejectReasonAllGet: function () {
      var self = this
      var callback = function () {
        self.lastRejectreason = ''
        for (var i = 0; i < self.$store.getters.rejectreasonsAll.length; i++) {
          var rejectreasons = self.$store.getters.rejectreasonsAll[i]
          if (rejectreasons.id === self.proposeDetail.attributes['reject-reason-id']) {
            self.lastRejectreason = rejectreasons.attributes['reject-reason']
            break
          }
        }
      }
      this.$store.dispatch('REJECT_REASON_ALL_GET', {callback: callback})
    },
    goBack: function () {
      this.$router.push({path: '/propose_unapproved_list/'})
    },
    content: function (word) {
      return word ? word.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;').replace(/\r?\n/g, '<br>') : ''
    },
    approve: function () {
      if (window.confirm(this.$t('Approve Confirm'))) {
        var data = {}
        if (this.validation.approved_reason_content) {
          data = {
            approved_reason_content: this.approvedReason.content
          }
          this.$store.dispatch('PROPOSE_APPROVE', { id: this.$route.params.id, data: data, callback: this.goBack })
        }
      }
    },
    notApprove: function () {
      if (window.confirm(this.$t('Not Approve Confirm'))) {
        var data = {}
        if (this.validation.reject_reason) {
          data = {
            reject_reason_id: this.rejectReason.id,
            reject_reason_content: this.rejectReason.content
          }
          this.$store.dispatch('PROPOSE_NOT_APPROVE', { id: this.$route.params.id, data: data, callback: this.goBack })
        }
      }
    },
    openRejectForm: function () {
      this.isReject = true
    },
    openApproveForm: function () {
      this.isApprove = true
    },
    selectedRejectReason: function () {
      var self = this
      self.rejectReason.content = ''
      for (var i = 0; i < self.$store.getters.rejectreasonsAll.length; i++) {
        var rejectreasons = self.$store.getters.rejectreasonsAll[i]
        if (rejectreasons.id === self.rejectReason.id) {
          self.rejectReason.content = rejectreasons.attributes['reject-reason-default-content']
          break
        }
      }
    },
    /** 画像押下 */
    onClickImageModalShow: function (number) {
      var button = document.getElementById('imageModalButton')
      var img = document.getElementById('imageModalImg')
      var text = document.getElementById('imageModalText')
      if (number === 1) {
        img.src = this.proposeDetail.attributes['propose-1-image-path'] + '?token=' + this.authToken + '&timestamp=' + this.timeStamp
      } else if (number === 2) {
        img.src = this.proposeDetail.attributes['propose-2-image-path'] + '?token=' + this.authToken + '&timestamp=' + this.timeStamp
      } else if (number === 3) {
        img.src = this.proposeDetail.attributes['propose-3-image-path'] + '?token=' + this.authToken + '&timestamp=' + this.timeStamp
      }
      text.textContent = ''
      button.click() // モーダル表示 イベント発火
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/propose-unapproved-detail.js